import SimpleText from './simpleText'

export default SimpleText